<line-chart
  [resource]="traffic"
  [metadata]="trafficMetadata()"
  [customization]="customization()"
  [defaultPeriod]="'1D'"
  [(dateRange)]="dateRangeOfInterest"
/>
